module.exports = __webpack_public_path__ + "static/how-it-works-step1-1c8479b69a3e73677e88e3b5d57945d6.svg";